import { Link } from "react-router-dom";

/** Reached by typing a URL, or by a stale link from an older build of the app. */
export function NotFound() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-4 text-center">
      <h1 className="text-xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-sm text-text-muted">There is nothing at this address.</p>
      <Link to="/" className="text-sm font-medium text-accent hover:underline">
        Back to the app
      </Link>
    </main>
  );
}
